import { multipleValuesActionsSupportedVisualizations } from "views/Constants";
const hasMultipleValueForActions = (actionContexts) => {
  var _a;
  return !!(((_a = actionContexts == null ? void 0 : actionContexts.valuePath) == null ? void 0 : _a.length) && multipleValuesActionsSupportedVisualizations.includes(actionContexts.widget.config.visualization));
};
export default hasMultipleValueForActions;
